import styled from "@emotion/styled";
import { Dialog } from "../common/modal/Dialog";

export const FullScreenLayoutWrapper = styled(Dialog)`
  top: 0 !important;
`;
